import { AsyncPipe, NgClass } from '@angular/common';
import { Component, forwardRef } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EzInputComponent } from 'src/app/shared/components/ez-input/ez-input.component';
import { EzInputDirective } from 'src/app/shared/components/ez-input/ez-input.directive';
import {
  IndexAddressStepAbstract
} from 'src/app/layout/common/components/order-form/step-address/index-address-step.abstract';

@UntilDestroy()
@Component({
    selector: 'app-index-address-step',
    templateUrl: './index-address-step.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => IndexAddressStepComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => IndexAddressStepComponent),
            multi: true,
        }
    ],
    imports: [
    NgClass,
    AsyncPipe,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatInputModule,
    EzInputComponent,
    EzInputDirective
]
})
export class IndexAddressStepComponent extends IndexAddressStepAbstract { }
